import { ButtonColor } from "@/common/enum/button-color";
import { Button, TextInput } from "flowbite-react";
import React from "react";

interface MemoInputProps {
  value: string;
  index: number;
  onChange: (index: number, value: string) => void;
  onRemove: (index: number) => void;
  onAdd: () => void;
  isMaxMemos: boolean;
}

export const MemoInput: React.FC<MemoInputProps> = ({
  value,
  index,
  onChange,
  onRemove,
  onAdd,
  isMaxMemos,
}) => {
  return (
    <div className="flex items-center gap-[8px]">
      <TextInput
        className="w-[300px]"
        value={value}
        onChange={(e) => onChange(index, e.target.value)}
        placeholder="ex) 맞춤 제작 레일 사이즈"
      />
      <Button
        onClick={() => onRemove(index)}
        color={ButtonColor.CUSTOM_GRAY}
        className="w-[32px]"
      >
        -
      </Button>
      <Button
        onClick={onAdd}
        color={ButtonColor.CUSTOM_GRAY}
        disabled={isMaxMemos}
        className="w-[32px]"
      >
        +
      </Button>
    </div>
  );
};
